import CaseManager from './components/case-manager.js'
import InterventionList from './components/intervention-list.js'
import ScoreMeter from './components/score-meter.js'
import FormNotice from './components/form-notice.js'
import DetailsPanel from './components/details-panel.js'
import './components/icons.js'

import RiskAssessmentForm from './risk-assessment-form.js'



// May end up using IndexedDB instead, but trying out localStorage for now:
// https://www.grizzlypeaksoftware.com/library/vanilla-javascript-patterns-for-modern-browsers-9jkhhape#heading-13
window.Storage = (function() {
  const prefix = ''

  function testAvailability() {
    try {
      let test = '__storage_test__'
      localStorage.setItem(test, test)
      localStorage.removeItem(test)
      return true
    } catch (error) {
      console.warn('Local storage is not available', error)
      return false
    }
  }

  const isAvailable = testAvailability()
  const fallback = {}

  return {
    get: function(key, defaultValue) {
      if (!isAvailable) return fallback[prefix + key] || defaultValue
      try {
        var item = localStorage.getItem(prefix + key)
        if (item === null) return defaultValue
        return JSON.parse(item)
      } catch (e) {
        return defaultValue
      }
    },
    set: function(key, value) {
      if (!isAvailable) {
        fallback[prefix + key] = value
        return true
      }
      try {
        localStorage.setItem(prefix + key, JSON.stringify(value))
        return true
      } catch (error) {
        console.warn('Storage quota exceeded for key:', key, error)
        return false
      }
    },
    remove: function(key) {
      if (!isAvailable) {
        delete fallback[prefix + key]
        return
      }
      localStorage.removeItem(prefix + key)
    },
    clear: function() {
      if (!isAvailable) {
        fallback = {}
        return
      }
      Object.keys(localStorage).forEach(function(key) {
        if (key.indexOf(prefix) === 0) {
          localStorage.removeItem(key)
        }
      })
    }
  }
})();






const assessmentFormEl = document.querySelector('[data-assessment-form]')
if (assessmentFormEl) {
  new RiskAssessmentForm(assessmentFormEl)
}

if ('customElements' in window) {
  customElements.define('case-manager', CaseManager)
  customElements.define('form-notice', FormNotice)
  customElements.define('intervention-list', InterventionList)
  customElements.define('score-meter', ScoreMeter)
  customElements.define('details-panel', DetailsPanel)
}
